import { TemplateRubricName } from "features/Influencer/ContactList/schema";

export const RubricNameToDescription: Record<TemplateRubricName, string> = {
  [TemplateRubricName.outreach_default]: "Outreach Rubric",
  [TemplateRubricName.followup_default]: "Followup Rubric",
};
